import { bool, func, object } from 'prop-types';
import { ModalStyled, ModalActionsStyled, TextStyled, ButtonStyled } from '@nike/nike-design-system-components';

import Spinner from '../../../components/spinner/Spinner';

const ConfirmDeleteModal = ({ isOpen, closeModal, onConfirm, item, requestInProgress }) => {
  return (
    <ModalStyled isOpen={isOpen} closeModal={closeModal} title='Confirm Delete'>
      <TextStyled appearance='body2'>Are you sure you want to delete {item.productCode} from this order?</TextStyled>
      {requestInProgress && (
        <div style={{ position: 'relative', zIndex: 2, top: '20px' }}>
          <Spinner className='relative-container' />
        </div>
      )}
      <ModalActionsStyled>
        <ButtonStyled type='button' appearance='primary' onClick={onConfirm} disabled={requestInProgress}>
          Delete
        </ButtonStyled>
        <ButtonStyled type='button' appearance='secondary' onClick={closeModal} disabled={requestInProgress}>
          Cancel
        </ButtonStyled>
      </ModalActionsStyled>
    </ModalStyled>
  );
};

ConfirmDeleteModal.propTypes = {
  isOpen: bool.isRequired,
  closeModal: func.isRequired,
  onConfirm: func.isRequired,
  item: object.isRequired,
  requestInProgress: bool.isRequired
};

export default ConfirmDeleteModal;
